import { DevPreview } from './components/DevPreview'
import { Header } from './components/sections/Header'
import { Hero } from './components/sections/Hero'
import { Partners } from './components/sections/Partners'
import { Stats } from './components/sections/Stats'
import { HowItWorks } from './components/sections/HowItWorks'
import { Cases } from './components/sections/Cases'
import { Why } from './components/sections/Why'
import { LeadQuality } from './components/sections/LeadQuality'
import { Dashboard } from './components/sections/Dashboard'
import { CtaFinal } from './components/sections/CtaFinal'
import { Footer } from './components/sections/Footer'
import { useSectionViews } from './hooks/useSectionViews'

function App() {
  useSectionViews()

  return (
    <DevPreview>
      <div className="min-h-screen overflow-x-clip bg-white">
        <Header />
        <Hero />
        <Partners />
        <Stats />
        <HowItWorks />
        <Cases />
        <Why />
        <LeadQuality />
        <Dashboard />
        <CtaFinal />
        <Footer />
      </div>
    </DevPreview>
  )
}

export default App
